import { instagramProfileRegExp, telegramProfileRegExp, vkProfileRegExp } from './regexps';

const toSocialProfileUrl = (value: string | undefined, re: RegExp, baseUrl: string) => {
    if (!value?.trim()) {
        return value;
    }

    const trimmed = value.trim();
    const username = trimmed.match(re)?.[1];

    if (!username) {
        return value;
    }

    if (/^https:\/\//.test(trimmed)) {
        return trimmed;
    }

    return `${baseUrl}${username}`;
};

export const toInstagramProfileUrl = (value?: string) =>
    toSocialProfileUrl(value, instagramProfileRegExp, 'https://www.instagram.com/');

export const toTelegramProfileUrl = (value?: string) =>
    toSocialProfileUrl(value, telegramProfileRegExp, 'https://t.me/');

export const toVkProfileUrl = (value?: string) =>
    toSocialProfileUrl(value, vkProfileRegExp, 'https://vk.com/');
